import React from 'react';
import { motion } from 'framer-motion';
import { Zap, Sparkles, DollarSign } from 'lucide-react';
export function ValueProps() {
  const props = [{
    icon: Zap,
    title: 'FAST',
    description: 'Same-day and next-day pickups. We show up on time, every time.'
  }, {
    icon: Sparkles,
    title: 'CLEAN',
    description: 'Tarped trucks, swept driveways. We leave your space better than we found it.'
  }, {
    icon: DollarSign,
    title: 'AFFORDABLE',
    description: 'Straightforward pricing. No hidden fees. Free quotes in minutes.'
  }];
  return <section className="relative py-16 md:py-20 bg-gradient-to-b from-navy to-[#1a2332]" data-id="element-219">
      <div className="container mx-auto px-4" data-id="element-220">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-12" data-id="element-221">
          {props.map((prop, index) => <motion.div key={prop.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="text-center space-y-4 pb-6" data-id="element-222">
              {/* Icon */}
              <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 rounded-2xl bg-lime/10 border-2 border-lime shadow-[0_0_20px_rgba(163,230,53,0.3)]" data-id="element-223">
                <prop.icon className="w-8 h-8 md:w-10 md:h-10 text-lime" strokeWidth={2.5} data-id="element-224" />
              </div>

              {/* Title */}
              <h3 className="font-heading text-3xl md:text-4xl text-lime tracking-wider" data-id="element-225">
                {prop.title}
              </h3>

              {/* Description */}
              <p className="text-white/80 text-base md:text-lg leading-relaxed max-w-xs mx-auto" data-id="element-226">
                {prop.description}
              </p>
            </motion.div>)}
        </div>
      </div>

      {/* Diagonal slash divider */}
      <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-b from-[#1a2332] to-navy clip-diagonal" data-id="element-227" />
    </section>;
}